import { Component, OnInit, Output, EventEmitter, Input, OnChanges } from '@angular/core';
import * as _ from 'lodash';

import {
  FiltersService
} from '../../services';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit, OnChanges {
  @Output() values = new EventEmitter();

  @Input() checkboxActive = [];

  checkboxData;

  constructor( private filtersService: FiltersService ) { }

  ngOnInit() {
    this.listTypesService();
  }

  ngOnChanges(changes) {
    if (!changes.checkboxActive.firstChange) {
      if (changes.checkboxActive.currentValue) {
        this.activeCheckbox();
      }
    }
  }

  listTypesService() {
    this.checkboxData = [];

    this.filtersService.listTypesServices().subscribe((response) => {
      for (let i = 0; i < response['data'].length; i++) {
        this.checkboxData.push({
          cdTpServico: response['data'][i].cdTpServico,
          dsTpServico: response['data'][i].dsTpServico,
          checked: false
        });
      }
    });
  }

  toggleCheckbox(index, value) {
    for (let i = 0; i < this.checkboxData.length; i++) {
      if (index == i && this.checkboxData[i].checked == false) {
        this.checkboxData[i].checked = true;

        this.checkboxActive.push({ cdTpServico: value });
      } else if (index == i && this.checkboxData[i].checked == true) {
        this.checkboxData[i].checked = false;

        _.remove(this.checkboxActive, function(n) {
          return n.cdTpServico == value;
        });
      }
    }

    this.values.emit(this.checkboxActive);
  }

  activeCheckbox() {
    if(this.checkboxData.length > 0) {
      for (let i = 0; i < this.checkboxData.length; i++) {
        let find = _.find(this.checkboxActive, ['cdTpServico', this.checkboxData[i].cdTpServico]);

        if(find) {
          if (this.checkboxData[i].cdTpServico == find.cdTpServico) {
            this.checkboxData[i].checked = true;
          }
        } else {
          this.checkboxData[i].checked = false;
        }
      }
    } else {
      this.activeCheckbox();
    }
  }

}
